import React from 'react';
import {
    ACTION_DOWN, ACTION_DOWN_LEFT, ACTION_DOWN_RIGHT,
    ACTION_LEFT, ACTION_RELAX, ACTION_RIGHT,
    ACTION_UP, ACTION_UP_LEFT, ACTION_UP_RIGHT,
    ACTION_CENTER
} from "../../tools/EyeActions";
import { getAvatarState } from "./avatarUtils";

const pupilOffsets = {
    [ACTION_LEFT]:       { x: -7, y: 0 },
    [ACTION_RIGHT]:      { x: 7, y: 0 },
    [ACTION_UP]:         { x: 0, y: -7 },
    [ACTION_DOWN]:       { x: 0, y: 7 },
    [ACTION_UP_LEFT]:    { x: -5, y: -5 },
    [ACTION_UP_RIGHT]:   { x: 5, y: -5 },
    [ACTION_DOWN_LEFT]:  { x: -5, y: 5 },
    [ACTION_DOWN_RIGHT]: { x: 5, y: 5 },
    [ACTION_CENTER]:     { x: 0, y: 0 },
    [ACTION_RELAX]:      { x: 0, y: 0 },
};

class MooseAvatar extends React.Component {
    render() {
        const { offset, isRelax, containerSize, isBlink, pulseClass } = getAvatarState(this.props, pupilOffsets);

        return (
            <div className="avatar-holder" style={{ width: containerSize, height: containerSize * 0.85 }}>
                <svg viewBox="-5 -10 210 185" className="avatar-svg">
                    {/* Antlers */}
                    <g fill="var(--avatar-antler)" stroke="var(--avatar-outline)" strokeWidth="1.5">
                        <path d="M68 48 L52 22 Q42 8 28 12 Q14 16 18 30 Q22 42 34 38 L42 34 Q32 46 38 48 Q44 50 52 44 Z" />
                        <path d="M24 14 L16 4" stroke="var(--avatar-antler)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
                        <path d="M18 26 L8 22" stroke="var(--avatar-antler)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
                    </g>
                    <g fill="var(--avatar-antler)" stroke="var(--avatar-outline)" strokeWidth="1.5">
                        <path d="M132 48 L148 22 Q158 8 172 12 Q186 16 182 30 Q178 42 166 38 L158 34 Q168 46 162 48 Q156 50 148 44 Z" />
                        <path d="M176 14 L184 4" stroke="var(--avatar-antler)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
                        <path d="M182 26 L192 22" stroke="var(--avatar-antler)" strokeWidth="3.5" fill="none" strokeLinecap="round" />
                    </g>

                    {/* Ears */}
                    <ellipse cx="60" cy="58" rx="11" ry="16" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.8" transform="rotate(-20 60 58)" />
                    <ellipse cx="60" cy="58" rx="6" ry="10" fill="var(--avatar-inner)" transform="rotate(-20 60 58)" />
                    <ellipse cx="140" cy="58" rx="11" ry="16" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="1.8" transform="rotate(20 140 58)" />
                    <ellipse cx="140" cy="58" rx="6" ry="10" fill="var(--avatar-inner)" transform="rotate(20 140 58)" />

                    {/* Head & muzzle */}
                    <circle cx="100" cy="85" r="54" fill="var(--avatar-primary)" stroke="var(--avatar-outline)" strokeWidth="2.2" />
                    <ellipse cx="100" cy="80" rx="36" ry="34" fill="var(--avatar-secondary)" opacity="0.3" />
                    <ellipse cx="100" cy="110" rx="28" ry="20" fill="var(--avatar-secondary)" stroke="var(--avatar-outline)" strokeWidth="1.5" />

                    {/* Eyes */}
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '78px 78px' }}>
                        <ellipse cx="78" cy="78" rx="16" ry={isRelax ? 2.5 : 15} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={78 + offset.x} cy={78 + offset.y} r="7.5" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={78 + offset.x - 2.5} cy={78 + offset.y - 2.5} r="2.5" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>
                    <g className={isBlink ? 'avatar-eye-blink' : ''} style={{ transformOrigin: '122px 78px' }}>
                        <ellipse cx="122" cy="78" rx="16" ry={isRelax ? 2.5 : 15} fill="var(--avatar-eye-white)" stroke="var(--avatar-outline)" strokeWidth="1.5" style={{ transition: 'ry 0.3s ease' }} />
                        {!isRelax && (<>
                            <circle className={pulseClass} cx={122 + offset.x} cy={78 + offset.y} r="7.5" fill="var(--avatar-pupil)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                            <circle cx={122 + offset.x - 2.5} cy={78 + offset.y - 2.5} r="2.5" fill="var(--avatar-eye-shine)" style={{ transition: 'cx 0.2s ease, cy 0.2s ease' }} />
                        </>)}
                    </g>

                    {/* Nostrils & mouth */}
                    <ellipse cx="91" cy="112" rx="5" ry="4" fill="var(--avatar-nose)" />
                    <ellipse cx="109" cy="112" rx="5" ry="4" fill="var(--avatar-nose)" />
                    <path d="M92 122 Q100 128 108 122" fill="none" stroke="var(--avatar-outline)" strokeWidth="1.5" strokeLinecap="round" />
                </svg>
            </div>
        );
    }
}

export default MooseAvatar;
